<template>
  <div class="col-sm-1 col-1">
    <button @click="menuBarToggle" class="menu_bar_toggle">
      <div class="menu_bar"></div>
      <div class="menu_bar"></div>
      <div class="menu_bar"></div>
      <div
        v-show="menuBarShow"
        class="menu_bar_show"
        @mouseleave="menuBarShow = false"
      >
        <button class="pdf_download_button" @click.prevent="pdfDownload()">
          PDF download
        </button>
        <button class="permalink_button" v-b-modal.permalink_zur_seite>
          <span class="permalink">Seite: {{ pageNum }}</span>

          Permalink zur seite
        </button>
        <b-modal
          id="permalink_zur_seite"
          title="Permanenter Link zur Seite"
          ok-only
        >
          <button @click="permalinkRoute" class="get_textarea_button">
            Copy Permalink
          </button>
          <div class="textarea_feld"></div>
        </b-modal>
      </div>
    </button>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "MenuBar",
  props: {
    pageNum: {
      type: Number,
      required: false,
    },
    numPages: {
      type: Number,
      required: false,
    },
    fulltextpdf: {
      type: String,
      required: false,
    },
    url: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      menuBarShow: false,
      fullNamePdf: "Fleischmann_Tradition_and_Craft_For_Screen_Reading.pdf",
      pageUrl: this.url,
      textarea: document.getElementById("permalink_textarea"),
    };
  },

  methods: {
    selectAll() {
      this.$refs.input.select();
    },
    menuBarToggle: function() {
      this.menuBarShow = !this.menuBarShow;
    },
    pdfDownload: function() {
      axios({
        url: this.fulltextpdf,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = this.fullNamePdf;
        link.click();
        URL.revokeObjectURL(link.href);
      });
    },
    permalinkRoute: function() {
      this.pageUrl = window.location.href;
      const el = document.createElement("textarea");
      el.value = this.pageUrl;
      el.style.zIndex = "0";
      el.style.position = "relative";
      el.style.width = "350px";
      const textareaFeld = document.getElementsByClassName("textarea_feld")[0];
      textareaFeld.appendChild(el);
      el.select();
      document.execCommand("copy");
    },
  },
};
</script>

<style scoped>
.get_textarea_button {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  text-align: center;
  margin-bottom: 10px;
}

.permalink {
  visibility: hidden;
  /* width: 270px; */
  width: 170px;
  background-color: #bfbfbf;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 80px;
  right: 0%;
}
.permalink_button:hover .permalink {
  visibility: visible;
}
.pdf_download_button {
  border: none;
  background-color: transparent;
  padding: 10px 10px 5px 10px;
}
.permalink_button {
  border: none;
  background-color: transparent;
  padding: 5px 10px 10px 10px;
}
.pdf_download_button:hover {
  color: white;
}
.permalink_button:hover {
  color: white;
}

.menu_bar_show {
  top: 30px;
  right: -11%;
  z-index: 1;
  position: absolute;
  background-color: #bfbfbf;
  text-align: end;
  padding: 5px;
  margin: 0px;
  border-radius: 0.25rem;
  width: 170px;
}

div.col-1 {
  padding-right: 0px;
}
button.menu_bar_toggle {
  border: none;
  background-color: transparent;
  padding: 0px;
}
button:focus {
  outline: none;
}
.menu_bar {
  width: 22px;
}
.menu_bar:nth-child(1) {
  border-top: 3px solid rgba(0, 0, 0, 0.8);
  margin-bottom: 4px;
}
.menu_bar:nth-child(2) {
  border-top: 3px solid rgba(0, 0, 0, 0.8);
  margin-bottom: 4px;
}
.menu_bar:nth-child(3) {
  border-bottom: 3px solid rgba(0, 0, 0, 0.8);
}
@media (max-width: 1200px) {
  .menu_bar {
    width: 20px;
  }
}
@media (max-width: 768px) {
  .menu_bar {
    width: 18px;
  }
}
@media (max-width: 600px) {
  .menu_bar {
    width: 16px;
  }
  .menu_bar_show {
    width: 150px;
    font-size: 14px;
  }
  .permalink {
    width: 150px;
    top: 75px;
  }
}
@media (max-width: 414px) {
  .menu_bar {
    width: 14px;
  }
  div.col-1 {
    padding-left: 5px;
  }
  .menu_bar_show {
    width: 133px;
    font-size: 12px;
  }
  .permalink {
    width: 133px;
    top: 70px;
  }
}
@media (max-width: 319px) {
  .menu_bar {
    width: 12px;
  }
  .menu_bar_show {
    width: 115px;
    font-size: 10px;
  }
  .permalink {
    width: 115px;
    top: 65px;
  }
}
</style>
